import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';

bootstrapApplication(AppComponent, appConfig).catch((err) => {
  // El ErrorHandler global (core/error) aun no esta vivo aca: log crudo del fallo de bootstrap.
  // eslint-disable-next-line no-console
  console.error('[bootstrap] fallo al iniciar la aplicacion', err);
});
